



















import { AccountLogo } from 'mycorems-app-accounts';
import { HasTaskMixin } from '@/mixins';
import { Account } from '@/types';

interface Data {
  agency: Account|null,
}
export default HasTaskMixin.extend({
  props: {
    agencyId: {
      type: String,
      required: true,
    },
  },
  components: {
    AccountLogo,
  },
});
